// START IMPORTS
import { Text } from '@ltvco/refresh-lib/theme';
// END IMPORTS

/** Secondary line under the title; omit empty or undefined strings. */
export function renderOptionalMutedText(text: string | undefined) {
  if (text == null || text === '') {
    return null;
  }
  return (
    <Text
      variant="body2"
      color="text.secondary"
      sx={{ fontWeight: 400, lineHeight: 1.43 }}
    >
      {text}
    </Text>
  );
}
